<template>
  <div class="container">
    <div class="ui left aligned grid">
      <h1>{{title}} Assembly</h1>
    </div>

    <form class="ui form row segment" @submit.prevent="assemblyUpdate">
      <div class="ui grid stackable">
        <div class="row">
          <div class="eight wide column">
            <div class="field">
              <label>Machine</label>
              <div
                class="ui fluid selection search dropdown"
                :class="{'disabled': disabled}"
                id="MachineSelect"
              >
                <input
                  type="hidden"
                  name="machines"
                  v-model="machineId"
                  :required="!machineId"
                  id="Machine"
                  @change="onMachineChange"
                />
                <div class="default text">Select Machine</div>
                <i class="dropdown icon"></i>
                <i class="remove icon"></i>
                <div class="menu">
                  <div
                    class="item"
                    v-for="machine in machines"
                    :key="machine.value"
                    v-bind:data-value="machine.value"
                  >
                    {{ machine.text }}
                  </div>
                </div>
              </div>
            </div>

            <div class="field">
              <label>Assembly Name</label>
              <input
                type="text"
                name="AssemblyName"
                placeholder="Assembly Name"
                required
                v-model="name"
              />
            </div>

            <div v-if="!originalImagePath" class="field">
              <div class="four wide column">
                <label
                  for="imagePath"
                  class="ui primary button"
                  @click="uploadImage"
                >
                  <i class="fa fa-upload" aria-hidden="true"></i>
                  Assembly Image
                </label>
                <vue-base64-file-upload
                  id="imagePath"
                  name="imagePath"
                  class="v1"
                  accept="image/png,image/jpeg"
                  image-class="v1-image"
                  input-class="v1-image"
                  :max-size="customImageMaxSize"
                  @size-exceeded="onSizeExceeded"
                  @file="onFile"
                  @load="onLoad"
                  hidden
                />
              </div>
            </div>
          </div>
          <div v-if="originalImagePath" class="eight wide column">
            <div class="field">
              <div class="four wide column mb-4">
                <img
                  v-if="imagePath"
                  :src="imagePath"
                  id="imagePath"
                  name="imagePath"
                  width="400"
                />
                <img
                  v-if="originalImagePath && !imagePath"
                  :src="originalImagePath"
                  id="originalImagePath"
                  name="originalImagePath"
                  width="400"
                />
              </div>
              <div class="four wide column">
                <button class="ui primary button" @click="removeImage">
                  Remove Image
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label for="active" class="toggle label">Inactive</label>
            <div class="ui toggle checkbox">
              <input
                id="active"
                name="active"
                type="checkbox"
                tabindex="0"
                checked="checked"
                v-model="active"
              />
              <label for="active">Active</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="eight wide column">
            <div class="ui buttons">
              <button class="ui positive button">{{button}} Assembly</button>
              <div class="or"></div>
              <div class="ui light button" @click="$router.go(-1)">Cancel</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService();

import "semantic-ui-dropdown/dropdown.js";
import VueBase64FileUpload from "vue-base64-file-upload";

export default {
  name: "AssemblyDetails",
  components: {
    VueBase64FileUpload
  },
  data() {
    return {
      showModal: false,
      name: "",
      machine: "",
      machines: [],
      machineId: "",
      imagePath: "",
      originalImagePath: "",
      active: true,
      customImageMaxSize: 3, // megabytes
      url: "https://steeleimages.blob.core.windows.net/images/",
      error: "",
      button: "",
      title: ""
    };
  },
  mounted() {

    if (this.$route.params.id != undefined) {
      this.assemblyDetails();
      this.button = 'Save';
      this.title = 'Edit';
    } else {
      this.button = 'Add';
      this.title = 'Add';
    }
    this.getMachineSelectedItems();

    $(".ui.dropdown").dropdown({fullTextSearch:true, sortSelect: true, match:'text'});
  },
  computed: {
    disabled() {
      if (this.$route.params.id == undefined) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    uploadImage() {
      $("#imagePath input").click();
    },
    onFile(file) {
      this.createImage(file);
      // console.log(file); // file object
    },
    onLoad(dataUri) {
      this.imagePath = dataUri;
      // console.log(dataUri); // data-uri string
    },
    onSizeExceeded(size) {
      alert(
        `Image ${size}Mb size exceeds limits of ${this.customImageMaxSize}Mb!`
      );
    },
    // Used this codepen for image upload with vuejs
    // https://codepen.io/Atinux/pen/qOvawK/
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      // var imagePath = new Image();
      var reader = new FileReader();
      var vm = this;
      this.originalImagePath = file.name;

      reader.onload = (e) => {
        vm.imagePath = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function() {
      this.originalImagePath = "";
      this.imagePath = "";
    },
    onMachineChange(event) {
      this.machineId = event.target.value;
    },
    getMachineSelectedItems() {
      apiService.getMachinesList().then((data) => {
        this.machines = data;

        if(this.machineId != null) {
          let _this = this;
          setTimeout(function() {
            $("#MachineSelect").dropdown("set selected", _this.machineId);
          }, 2000);
        }
      });
    },
    assemblyDetails() {
      apiService
        .getAssemblyDetails({ id: this.$route.params.id })
        .then((request) => {
          this.assemblySuccessful(request);
          let _this = this;
          setTimeout(function() {
            $("#MachineSelect").dropdown("set selected", _this.machineId);
          }, 2000);
        })
        .catch((err) => this.assemblyFailed(err));
      // console.log(this.machines);
    },
    assemblySuccessful(request) {
      (this.name = request.name),
      (this.machine = request.machine),
      (this.machineId = request.machineId),
      (this.originalImagePath = request.originalImagePath),
      (this.active = request.active);

      if (request.imagePath != null) {
        this.imagePath = this.url + request.imagePath;
      }
    },
    assemblyFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    assemblyUpdate() {
      if (this.$route.params.id == undefined) {
        apiService
          .createAssembly({
            name: this.name,
            machine: this.machine,
            machineId: this.machineId,
            imagePath: (this.imagePath != undefined ? this.imagePath : null),
            originalImagePath: this.originalImagePath,
            Active: this.active,
            error: false,
          })
          .then(() => {
            this.$router.push("/admin/assembly");
          })
          .catch((err) => this.assemblyFailed(err));
      } else {
        apiService
          .updateAssembly({
            id: this.$route.params.id,
            name: this.name,
            machine: this.machine,
            machineId: this.machineId,
            imagePath: this.imagePath,
            originalImagePath: this.originalImagePath,
            Active: this.active,
            error: false,
          })
          .then(() => {
            this.$router.push("/admin/assembly");
          })
          .catch((err) => this.assemblyFailed(err));
      }
    },
  },
};
</script>

<style module></style>
